import { useEffect } from 'react';

export const useArticleTextSelectionHandler = (onArticleTextSelection: () => void, deps: any[]) => {
  useEffect(() => {
    document.addEventListener('mouseup', onArticleTextSelection);
    return () => {
      document.removeEventListener('mouseup', onArticleTextSelection);
    };
  }, [...deps, onArticleTextSelection]);
};
